<template>
  <div>
    <!-- Text 입력 (JoditEditor 사용) -->
    <label for="content">{{ $t('label.39') }}</label>
    <JoditEditor 
      id="content"
      v-model="content.practiceText" 
      :config="editorConfig"
    />

    <!-- 정답 표시 -->
    <div class="game-section">
      <h6 class="mt-3">Answer</h6>
      <div v-for="(option, index) in content.options" :key="index" class="game-item gameCard">
        <div class="row">
          <div class="col-6">
            <input
              v-model="option.option_text"
              placeholder="Option Text"
              class="form-control"
            />
          </div>
          <div class="col-6">
            <input
              v-model="option.option_answer"
              placeholder="Option Answer"
              class="form-control"
            />
          </div>
        </div>
        <button @click.prevent="removeOption(index)" class="btn-remove mt-2">Remove</button>
      </div>
      <button @click.prevent="addOption" class="btn btn-primary mt-2">Add Option</button>
    </div>
    
  </div>
</template>

<script setup>
import { 
  defineModel, 
  ref,
  onMounted
} from 'vue';
import { useRoute } from 'vue-router';
import JoditEditor from '@/components/JoditEditor.vue';
import axios from 'axios';
import CONF from "@/Config.js";
import eventBus from '@/eventBus'

const route = useRoute();
const editorRef = ref(null);

const content = defineModel({ type: Object, required: true });

const addOption = () => {
  if (!content.value.options) content.value.options = [];
  content.value.options.push({ option_text: '', option_answer: '' });
};

const removeOption = (index) => {
  content.value.options.splice(index, 1);
};


// JoditEditor 설정
const editorConfig = {
  minHeight: 500,
  events: {
    afterInit: (editor) => {
      editorRef.value = editor;
      loadStyleFiles();
    }
  }
};

// 스타일 파일 로드 함수
const loadStyleFiles = async () => {
  try {
    const barcode = route.query.barcode;
    const token = localStorage.getItem("access_token");
    
    const [contents] = await Promise.all([
      axios.get(`${CONF.API_URL}/textbook/editor/textbookContents/${barcode}/style`, {
        headers: { Authorization: `Bearer ${token}` }
      }),
    ]);

    // 스타일 태그 생성 및 추가
    if (contents.data?.content) {
      const styleTag = document.createElement('style');
      // 모든 CSS 변수를 직접 값으로 변환하여 적용
      const cssContent = contents.data.content.replace(/var\(--[^)]+\)/g, (match) => {
        const computedStyle = getComputedStyle(document.documentElement);
        const cssVar = match.slice(4, -1); // 'var(--xxx)' 에서 '--xxx' 추출
        return computedStyle.getPropertyValue(cssVar).trim();
      });
      
      styleTag.textContent = `
        .jodit-wysiwyg {
          ${cssContent}
        }
        .jodit-wysiwyg * {
          ${cssContent}
        }
      `;
      styleTag.id = 'editor-contents-style';
      const existingStyle = document.getElementById('editor-contents-style');
      if (existingStyle) {
        existingStyle.remove();
      }
      document.head.appendChild(styleTag);
    }

  } catch (error) {
    console.error('스타일 파일 로드 실패:', error);
  }
};

onMounted(() => {
  //console.log('초기 sectionData 값:', content.value);
});

// 이벤트 버스 사용
eventBus.on('loadStyleFiles', loadStyleFiles);
</script>

<style scoped>
.game-section {
  margin-top: 20px;
}
.game-item {
  margin-bottom: 15px;
}
.gameCard {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  border: 1px solid gray;
}
.btn-remove {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}
.btn-remove:hover {
  text-decoration: underline;
}
</style>
  